<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <v-btn
        small
        text
        rounded
        fab
        color="success"
        :to="{ name: 'ComboList'}">
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
    </div>

    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="comboList.models"
        :options="table.options"
        :footer-props="{'items-per-page-options': [50, 100]}"
        @update:options="updateTable"
        class="elevation-1">
        <template v-slot:item.section="{ item }">
          <span v-if="item.section">
            {{ item.section.name }}
          </span>
          <span v-else>
            -
          </span>
        </template>
        <template v-slot:item.cost="{ item }">
          {{ item.cost | toFixNumber(2) | numberWithComma | prefix('$') }}
        </template>
        <template v-slot:item.price="{ item }">
          <span v-if="item.price >= 0">
            ${{ item.price | toFix2 | numberWithComma }}
          </span>
          <span v-else>
            -
          </span>
        </template>
        <template v-slot:item.status="{ item }">
         {{item.status === 'archived' ? 'Archivado' : item.status}}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end align-center">
            <div class="mx-1">
                <v-tooltip left>
                  <template
                    v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      fab
                      x-small
                      depressed
                      color="primary"
                      @click="openArchiveComboDialog(item)"
                    >
                      <v-icon
                        icon
                        small
                      >mdi-archive</v-icon>
                    </v-btn>
                  </template>
                <span>Desarchivar receta</span>
                </v-tooltip>
            </div>
            <div class="mx-1">
              <v-tooltip left>
                <template
                  v-slot:activator="{ on }">
                  <v-btn
                    fab
                    x-small
                    depressed
                    color="error"
                    v-on="on"
                    @click="openRemoveComboDialog(item)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar receta</span>
              </v-tooltip>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <v-dialog @keydown.esc="archiveComboDialog=false" v-model="archiveComboDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span>¿Desarchivar el paquete {{ dataCombo.name }}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="onCloseArchiveComboDialog">{{ $t('messages.no') }}</v-btn>
          <v-btn color="black darken-1" text @click="unArchiveCombo">{{ $t('messages.yes') }}</v-btn>
        </v-card-actions>
      </v-card>
      <v-overlay :value="overlayDialog" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    </v-dialog>

   <v-dialog @keydown.esc="removeComboDialog=false" v-model="removeComboDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span>¿Eliminar la paquete {{ dataCombo.name }}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="onCloseRemoveComboDialog">{{ $t('messages.no') }}</v-btn>
          <v-btn color="black darken-1" text @click="remove">{{ $t('messages.yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import Combo from '@/models/Combo'
import ComboList from '@/models/collections/ComboList'

export default {
  name: 'ArchivedCombos',
  data () {
    let comboList = new ComboList()
    let combo = new Combo({}, comboList)

    return {
      combo,
      comboList,
      overlay: false,
      section: 'Paquetes archivados',
      table: {
        title: 'Paquetes archivados',
        loading: false,
        headers: [
          { text: 'Nombre', value: 'name', sortable: false },
          { text: 'Precio de venta', value: 'price', sortable: false },
          { text: 'Costo', value: 'cost', sortable: false },
          { text: 'Sección', value: 'section', sortable: false },
          { text: 'Estatus', value: 'status', sortable: false },
          { text: 'Acciones', value: 'actions', sortable: false }
        ],
        data: [],
        options: {
          itemsPerPage: 50,
          page: 1
        }
      },
      archiveRecipeDialog: false,
      form: {
        data: {
          internalId: null,
          name: null,
          status: null,
          subrecipe: false,
          restaurant: null,
          area: null,
          section: null
        }
      },
      overlayDialog: false,
      removeComboDialog: false,
      archiveComboDialog: false,
      dataCombo: {}
    }
  },
  computed: {
    restaurant () {
      return this.$store.state.currentRestaurant.data
    }
  },
  watch: {
    restaurant: {
      handler: async function (val) {
        await this.load()
      },
      deep: true
    }
  },
  async mounted () {
    await this.load()
  },
  methods: {
    openArchiveComboDialog (item) {
      this.dataCombo = item
      this.archiveComboDialog = true
    },
    onCloseArchiveComboDialog () {
      this.dataCombo = {}
      this.archiveComboDialog = false
    },
    async unArchiveCombo () {
      this.overlayDialog = true
      try {
        await this.$api.put(`/v1/combos/${this.dataCombo._id}/`, { status: 'attached' })
        this.onCloseArchiveComboDialog()
        await this.load()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlayDialog = false
    },
    updateTable: async function (data) {
      this.overlay = true
      const { sortBy, sortDesc } = data
      this.table.options = data
      await this.load({
        limit: data.itemsPerPage,
        skip: (data.itemsPerPage * (data.page - 1)),
        sort: `${sortDesc[0] ? '-' : ''}${sortBy[0]}`,
        status: 'archived'
      })
      this.overlay = false
    },
    async load (params = null) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        sort: 'name',
        status: 'archived'
      }
      try {
        const { response } = await this.combo.fetch({ params })
        this.comboList.replace([response.data.data])
        this.table.total = response.data.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    openRemoveComboDialog: async function (item) {
      this.dataCombo = item
      this.removeComboDialog = true
    },
    onCloseRemoveComboDialog: function () {
      this.dataCombo = {}
      this.removeComboDialog = false
    },
    remove: async function () {
      this.table.loading = true
      try {
        await this.$api.del(`/v1/combos/${this.dataCombo._id}`)
        this.onCloseRemoveComboDialog()
        await this.load()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    }
  }
}
</script>

<style lang="scss">
.action-black {
  color: black !important;
}
.z-index--100 {
  z-index: 100 !important;
}
</style>
